var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"d-md-flex d-sm-block"},[_c('div',[_c('div',{staticClass:"mr-md-4 mr-xs-0 aside"},[_c('sub-page-routes',{attrs:{"routes":_vm.routes}})],1)]),_c('div',{staticClass:"flex-grow-1"},[_c('keep-alive',{attrs:{"max":_vm.MAX_ROUTES_CACHE}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }